import React from 'react';
import { colors } from '../theme';

// Compact header block shown at the top of every RMA status modal so the
// service user immediately sees who the case belongs to and when it came in.
export default function RmaCustomerSummary({ rma }) {
  if (!rma) return null;

  const customerName = rma.customerName || rma.contactName || 'Unknown customer';
  const company = rma.contactOrg || '';
  const contactEmail = rma.contactEmail || rma.email || '';
  let submittedLabel = null;
  if (rma.submittedAt) {
    const date = new Date(rma.submittedAt);
    if (!Number.isNaN(date.getTime())) {
      submittedLabel = date.toLocaleDateString('en-CA');
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.35rem 1.5rem',
        margin: '0 0 0.75rem',
        padding: '0.6rem 0.75rem',
        borderRadius: '10px',
        border: `1px solid ${colors.panelBorder}`,
        backgroundColor: 'rgba(255,255,255,0.04)',
        textAlign: 'left'
      }}
    >
      <span style={{ fontSize: '0.9rem', color: colors.textBody }}>
        <strong style={{ color: colors.textStrong }}>Contact Person:</strong> {customerName}
      </span>
      {company && (
        <span style={{ fontSize: '0.9rem', color: colors.textBody }}>
          <strong style={{ color: colors.textStrong }}>Company:</strong> {company}
        </span>
      )}
      {contactEmail && (
        <span style={{ fontSize: '0.9rem', color: colors.textBody }}>
          <strong style={{ color: colors.textStrong }}>Email:</strong>{' '}
          <a href={`mailto:${contactEmail}`} style={{ color: colors.accent }}>{contactEmail}</a>
        </span>
      )}
      <span style={{ fontSize: '0.9rem', color: colors.textBody }}>
        <strong style={{ color: colors.textStrong }}>Submitted:</strong>{' '}
        {submittedLabel || 'Unknown'}
      </span>
    </div>
  );
}
